import { useState, useCallback, useRef } from 'react'
import { useSpring, animated } from 'react-spring'

import { Table } from './table/table'
import { DownloadLink } from '../../common/components/download-link'
import { csvExportService } from './csv-export.service'

import { useStyles } from './chart-flipper.style'
import { ChartSizer } from '../charts/common/chart-sizer'

export const ChartFlipper = function ({
  children,
  enabled = true,
  showTable = false,
  tableData,
  tableProps,
  dataKey,
  isHalf = false,
  tableStyles = {},
  tableOffset = 0,
  chartSideStyles = {},
  tableSideStyles = {}
}) {
  const classes = useStyles()

  const [containerHeight, setContainerHeight] = useState(0)
  const chartAnimatedDivRef = useRef()
  const tableAnimatedDivRef = useRef()
  const previousTableDataLength = useRef(0)

  const tableContainerRef = useCallback((node) => {
    if (node) {
      if (tableData.rows.length !== previousTableDataLength.current) {
        node.scroll({ top: 0 })
        previousTableDataLength.current = tableData.rows.length
      }
    }
    tableContainerRef.current = node
  }, [ tableData ])

  const { transform, opacity } = useSpring({
    opacity: showTable ? 1 : 0,
    transform: `rotateY(${showTable ? 180 : 0}deg)`,
    config: { mass: 1, tension: 500, friction: 80 }
  })

  function chartContainerRef (div) {
    if (!div) {
      return
    }

    const newContainerHeight = div.clientHeight - tableOffset
    if (newContainerHeight !== containerHeight) {
      setContainerHeight(newContainerHeight)
    }
  }

  if (!enabled) {
    return children
  }

  function printWidth (width) {
    return <Table tableData={tableData} {...tableProps} width={width} enableVirtualScrolling={true} isHalf={isHalf} />
  }

  return <>
    <animated.div
      className={showTable ? `${classes.chartSide} ${classes.hideToggle}` : `${classes.chartSide}`}
      style={{ opacity: opacity.to((o) => 1 - o), transform, pointerEvents: showTable ? 'none' : '', ...chartSideStyles }}
      ref={chartAnimatedDivRef}
      data-qa="chart-flipper-chart-side"
    >
      <div ref={chartContainerRef}>
        {children}
      </div>
    </animated.div>
    { tableData && (
      <animated.div
        className={!showTable ? `${classes.tableSide} ${classes.hideToggle}` : `${classes.tableSide}`}
        style={{ opacity, pointerEvents: showTable ? '' : 'none', ...tableSideStyles }}
        ref={tableAnimatedDivRef}
        data-qa="chart-flipper-table-side"
      >
        <div className={classes.table} ref={tableContainerRef} style={{ maxHeight: '400px', ...tableStyles }} data-qa="chart-flipper-table">
          <ChartSizer
            heightWidthRatio={0.5}
            heightViewportRatio={0.9}
            maxHeight={400}
          >
            {({ width, height }) => (

              printWidth(width)

            )}

          </ChartSizer>

        </div>
        <div className={classes.tableBottomFade} />
        <div className={classes.downloadLink}>
          <DownloadLink contentType="text/csv" fileName={`${dataKey}.csv`} data={csvExportService.mapChartDataToCsv(tableData)}/>
        </div>
      </animated.div>
    )}
  </>
}
